import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  asterisk: {
    display: 'none',
  },
  noAsterisk: {
    '&::after': {
      display: 'none !important',
    },
  },
  labelRoot: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.common.black,
    fontSize: theme.typography.body2.fontSize,
    fontWeight: 'bold',
    '& svg': {
      order: 3,
      marginLeft: theme.spacing(2),
    },
    '&::after': {
      order: 2,
      display: 'inline-block',
      marginLeft: theme.spacing(2),
      padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
      fontSize: 12,
      fontWeight: 'bold',
      content: '"任意"',
      color: theme.palette.common.white,
      backgroundColor: theme.palette.grey[500],
    },
    '& + $formControl': {
      marginTop: theme.spacing(3),
    },
  },
  required: {
    '&::after': {
      content: '"必須"',
      color: theme.palette.common.white,
      backgroundColor: theme.palette.error.main,
    },
  },
  formControl: {},
}));
